import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";

export default function NotFound() {
  return (
    <Layout>
      <section className="sayfa-basi" style={{ textAlign: "center" }} data-testid="not-found">
        <div className="veri">404</div>
        <h1 className="h-dev" style={{ margin: "14px 0 20px" }}>Bu sayfa yok</h1>
        <p style={{ color: "var(--metin-2)", marginBottom: 30 }}>Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.</p>
        <Link to="/" className="dugme">Ana sayfaya dön</Link>
      </section>
    </Layout>
  );
}
